import {Api} from './config/request';

const getPicturesList = () => (Api.getRequest('images'));

export const Pictures = {
    getPicturesList,
}